<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand"
    :class="{ 'navbar-dark': type === 'default' }"
  >
    <a
      href="#"
      aria-current="page"
      class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block active router-link-active"
    >
      {{ $route.name }}
    </a>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a
          class="nav-link"
          href="#"
          data-action="search-show"
          data-target="#navbar-search-main"
        >
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <li class="nav-item">
        <a class="nav-link nav-link-icon" @click="$router.push('/kasir')">
          <i class="fas fa-shopping-bag" style="color: black"></i>
          <span class="nav-link-inner--text d-lg-none">Kasir</span>
        </a>
      </li>
      <!-- <base-dropdown
        class="nav-item"
        menu-on-right
        tag="li"
        title-tag="a"
        v-if="$store.state.access_level"
      >
        <a
          slot="title-container"
          class="nav-link nav-link-icon"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-store-alt" style="color : black;"></i>
        </a>

        <a
          class="dropdown-item"
          v-for="tk in toko"
          :key="tk.id"
          @click="pindahtoko(tk.id)"
          :class="{ disabled: !tk.isPaidoff }"
          >{{ tk.nama }}
          <i v-if="tk.id == $store.state.tokoNow" class="ni ni-check-bold"></i
        ></a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="$router.push('/tambahtoko')"
          ><i class="ni ni-fat-add"></i>Tambah Toko Baru</a
        >
      </base-dropdown> -->
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <span
              class="avatar avatar-sm rounded-circle"
              style="background-color: white"
            >
              <img
                alt="Image placeholder"
                :src="$config.base_url + 'img/icons/BukaKasir.png'"
              />
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{
                $store.state.name
              }}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </b-dropdown-header>
          <b-dropdown-item @click="$router.push('/profile')">
            <i class="ni ni-single-02"></i>
            <span>Profile</span>
          </b-dropdown-item>
          <!-- <b-dropdown-item @click="$router.push('/absen')">
            <i class="ni ni-active-40"></i>
            <span>Absen</span>
          </b-dropdown-item> -->
          <b-dropdown-item
            v-if="$store.state.access_level"
            @click="$router.push('/settingtoko')"
          >
            <i class="ni ni-settings-gear-65"></i>
            <span>Setting Toko</span>
          </b-dropdown-item>
          <!-- <b-dropdown-item
            v-if="$store.state.access_level"
            @click="$router.push('/settingwebsite')"
          >
            <i class="ni ni-world"></i>
            <span>Setting Website</span>
          </b-dropdown-item> -->
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logout()">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
// import storeApi from "../../api/store";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      toko: [],
    };
  },
  // async created() {
  //   const { data } = await storeApi.list();
  //   if (data.success) {
  //     this.toko = data.data;
  //   }
  // },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    pindahtoko(toko_id) {
      var self = this;
      if (toko_id == this.tokonow) {
        this.$showInfo("Anda sudah berada pada toko tersebut");
      } else {
        self
          .$axios({
            method: "GET",
            url: self.$config.url_api + "toko/pindah_toko/" + toko_id,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
              Authorization: "Bearer " + self.$cookies.get("code"),
            },
          })
          .then(function (response) {
            if (response.data.status == "ok") {
              if (self.$route.path == "/settingtoko") {
                self.$router.go();
              } else {
                self.$router.push("settingtoko");
              }

              self.tokonow = toko_id;
            }
          })
          .catch((error) => {
            // console.log(error)
          });
      }
    },
    logout() {
      this.$cookies.remove("code");
      location.href = this.$config.base_url;
      // var self = this;
      // this.$axios({
      //   method: "POST",
      //   url: this.$config.url_api + "logout",
      //   headers: {
      //     Accept: "application/json",
      //     Authorization: "Bearer " + this.$cookies.get("code")
      //   }
      // })
      //   .then(function(response) {
      //     // console.log(response.data)
      //     if (response.data.status == "ok") {

      //       location.href = self.$config.base_url;
      //     }
      //   })
      //   .catch(error => {
      //     // console.log(error)
      //   });
    },
  },
};
</script>
